/**
 * Edit Company Modal Component
 */
import { X, Pencil } from "lucide-react";

export const EditCompanyModal = ({
  show,
  onClose,
  editForm,
  setEditForm,
  onSave,
  saving
}) => {
  if (!show) return null;

  const handleChange = (field, value) => {
    setEditForm(prev => ({ ...prev, [field]: value }));
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50">
      <div className="bg-white rounded-xl w-full max-w-lg p-6 animate-fadeIn max-h-[90vh] overflow-y-auto">
        <div className="flex items-center justify-between mb-4">
          <div className="flex items-center gap-2">
            <Pencil size={20} className="text-[#1B3F8F]" />
            <h3 className="text-lg font-semibold text-gray-900">Uredi podatke firme</h3>
          </div>
          <button onClick={onClose} className="p-2 hover:bg-gray-100 rounded-lg">
            <X size={20} className="text-gray-500" />
          </button>
        </div>
        
        <div className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Naziv firme</label>
            <input
              type="text"
              value={editForm.name || ""}
              onChange={(e) => handleChange("name", e.target.value)}
              className="w-full p-3 border border-gray-200 rounded-xl focus:ring-2 focus:ring-[#1B3F8F]/20 focus:border-[#1B3F8F]"
            />
          </div>
          
          <div className="grid grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Grad</label>
              <input
                type="text"
                value={editForm.city || ""}
                onChange={(e) => handleChange("city", e.target.value)}
                className="w-full p-3 border border-gray-200 rounded-xl focus:ring-2 focus:ring-[#1B3F8F]/20 focus:border-[#1B3F8F]"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">OIB</label>
              <input
                type="text"
                value={editForm.oib || ""}
                onChange={(e) => handleChange("oib", e.target.value)}
                className="w-full p-3 border border-gray-200 rounded-xl focus:ring-2 focus:ring-[#1B3F8F]/20 focus:border-[#1B3F8F]"
              />
            </div>
          </div>
          
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Adresa</label>
            <input
              type="text"
              value={editForm.address || ""}
              onChange={(e) => handleChange("address", e.target.value)}
              className="w-full p-3 border border-gray-200 rounded-xl focus:ring-2 focus:ring-[#1B3F8F]/20 focus:border-[#1B3F8F]"
            />
          </div>
          
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Industrija</label>
            <input
              type="text"
              value={editForm.industry || ""}
              onChange={(e) => handleChange("industry", e.target.value)}
              className="w-full p-3 border border-gray-200 rounded-xl focus:ring-2 focus:ring-[#1B3F8F]/20 focus:border-[#1B3F8F]"
            />
          </div>
          
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Procijenjena vrijednost akvizicije (KM)
            </label>
            <input
              type="number"
              step="0.01"
              min="0"
              value={editForm.estimated_value || ""}
              onChange={(e) => handleChange("estimated_value", e.target.value ? parseFloat(e.target.value) : null)}
              placeholder="npr. 50000.00"
              className="w-full p-3 border border-gray-200 rounded-xl focus:ring-2 focus:ring-[#1B3F8F]/20 focus:border-[#1B3F8F]"
            />
          </div>
          
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Ime direktora</label>
            <input
              type="text"
              value={editForm.director_name || ""}
              onChange={(e) => handleChange("director_name", e.target.value)}
              className="w-full p-3 border border-gray-200 rounded-xl focus:ring-2 focus:ring-[#1B3F8F]/20 focus:border-[#1B3F8F]"
            />
          </div>
          
          <div className="grid grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Telefon</label>
              <input
                type="tel"
                value={editForm.phone || ""}
                onChange={(e) => handleChange("phone", e.target.value)}
                className="w-full p-3 border border-gray-200 rounded-xl focus:ring-2 focus:ring-[#1B3F8F]/20 focus:border-[#1B3F8F]"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Email</label>
              <input
                type="email"
                value={editForm.email || ""}
                onChange={(e) => handleChange("email", e.target.value)}
                className="w-full p-3 border border-gray-200 rounded-xl focus:ring-2 focus:ring-[#1B3F8F]/20 focus:border-[#1B3F8F]"
              />
            </div>
          </div>
        </div>
        
        <div className="flex gap-3 mt-6">
          <button
            onClick={onClose}
            className="flex-1 py-3 px-4 border border-gray-200 rounded-xl text-gray-700 font-medium hover:bg-gray-50"
          >
            Odustani
          </button>
          <button
            onClick={onSave}
            disabled={saving}
            className="flex-1 py-3 px-4 bg-[#1B3F8F] text-white rounded-xl font-medium hover:bg-[#15327a] disabled:opacity-50"
          >
            {saving ? "Spremam..." : "Spremi"}
          </button>
        </div>
      </div>
    </div>
  );
};
